/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportCreateRequest } from '../models/ReportCreateRequest';
import type { ReportTemplateDetailResponse } from '../models/ReportTemplateDetailResponse';
import type { ReportUpdateRequest } from '../models/ReportUpdateRequest';
import type { TaskReportDetailResponse } from '../models/TaskReportDetailResponse';
import type { TaskReportFullResponse } from '../models/TaskReportFullResponse';
import type { TaskWithReportResponse } from '../models/TaskWithReportResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskReportService {
    /**
     * Get Workspace All Task Reports
     * 워크스페이스 내 모든 세부실행과제 보고서 조회
     *
     * 세부실행과제와 보고서 템플릿의 조합을 플랫 리스트로 반환합니다.
     * report_template_key가 없으면 각 Task에 대해 Business의 report_settings에서
     * ignored가 true로 설정되지 않은 모든 report template 조합을 반환합니다.
     * (예: Task 1개 × Template 2개 = 응답 2개)
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * business_id: 사업 ID (선택)
     * department_id: 부서 ID (선택)
     * assignee_id: 담당자 ID (선택)
     * sub_assignee_id: 부담당자 ID (선택)
     * manager_id: 관리자 ID (선택)
     * reviewer_id: 검토자 ID (선택)
     * stakeholder_id: 이해관계자 ID - 4개 역할 중 하나라도 해당되면 포함 (선택)
     * report_template_key: 보고서 템플릿 키 (선택) - 지정 시 해당 템플릿만 반환
     * start_date: 시작일 (YYYY-MM-DD 형식, end_date와 함께 사용)
     * end_date: 종료일 (YYYY-MM-DD 형식, start_date와 함께 사용)
     *
     * Returns:
     * List[TaskWithReportResponse]: 세부실행과제 보고서 목록 (Task × Template 조합)
     * @returns TaskWithReportResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetWorkspaceAllTaskReports({
        workspaceId,
        businessId,
        departmentId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        reportTemplateKey,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        businessId?: string,
        departmentId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        reportTemplateKey?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<Array<TaskWithReportResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/report/workspace-all',
            query: {
                'workspace_id': workspaceId,
                'business_id': businessId,
                'department_id': departmentId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'report_template_key': reportTemplateKey,
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
    /**
     * Get All Report Templates
     * 모든 보고서 템플릿 조회 (사업과 무관, 또는 사업별 정렬 적용)
     *
     * 코드에 정의된 모든 보고서 템플릿을 반환합니다.
     * 사업의 report_settings 설정과 무관하게 전체 템플릿 목록을 제공합니다.
     * business_id가 제공되면 해당 사업의 report_settings에 정의된 sort_key를 적용하여 정렬합니다.
     *
     * Args:
     * business_id: 사업 ID (선택) - 제공 시 해당 사업의 report_settings 기준으로 정렬
     *
     * Returns:
     * 200: List[ReportTemplateListResponse] - 모든 보고서 템플릿 목록
     * 401: Unauthorized
     * 500: Internal server error
     * @returns ReportTemplateDetailResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetAllReportTemplates({
        businessId,
    }: {
        /**
         * 사업 ID (선택) - 제공 시 해당 사업의 report_settings 기준으로 정렬
         */
        businessId?: string,
    }): CancelablePromise<Array<ReportTemplateDetailResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/report/template',
            query: {
                'business_id': businessId,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Report Templates By Workspace
     * 워크스페이스별 보고서 템플릿 조회 (코드 기반)
     *
     * 해당 워크스페이스의 모든 사업이 공통으로 무시하는 템플릿만 제외합니다.
     * 하나라도 사용하는 사업이 있으면 포함됩니다.
     * business_id가 제공되면 해당 사업의 report_settings에 정의된 sort_key를 적용하여 정렬합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (query parameter)
     * business_id: 사업 ID (선택) - 제공 시 해당 사업의 report_settings 기준으로 정렬
     *
     * Returns:
     * 200: List[ReportTemplateListResponse] - 보고서 템플릿 목록
     * 400: Validation error
     * 404: Workspace not found
     * 500: Internal server error
     * @returns ReportTemplateDetailResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetReportTemplatesByWorkspace({
        workspaceId,
        businessId,
    }: {
        /**
         * 워크스페이스 ID
         */
        workspaceId: string,
        /**
         * 사업 ID (선택) - 제공 시 해당 사업의 report_settings 기준으로 정렬
         */
        businessId?: string,
    }): CancelablePromise<Array<ReportTemplateDetailResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/report/template/workspace-all',
            query: {
                'workspace_id': workspaceId,
                'business_id': businessId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * 과제 보고서 HTML 생성
     * 과제 보고서를 HTML 형식으로 생성합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsTaskViewsGenerateTaskReportHtml({
        taskId,
        reportKey,
    }: {
        taskId: string,
        reportKey: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/{task_id}/report/{report_key}/html',
            path: {
                'task_id': taskId,
                'report_key': reportKey,
            },
        });
    }
    /**
     * 과제 보고서 PDF 생성
     * 과제 보고서를 PDF 형식으로 생성합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsTaskViewsGenerateTaskReportPdf({
        taskId,
        reportKey,
        download = true,
    }: {
        taskId: string,
        reportKey: string,
        /**
         * 다운로드 여부 (true=다운로드, false=미리보기)
         */
        download?: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/{task_id}/report/{report_key}/pdf',
            path: {
                'task_id': taskId,
                'report_key': reportKey,
            },
            query: {
                'download': download,
            },
        });
    }
    /**
     * 과제 보고서 HWPX 생성
     * 과제 보고서를 HWPX(한글) 형식으로 생성합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsTaskViewsGenerateTaskReportHwpx({
        taskId,
        reportKey,
        download = true,
    }: {
        taskId: string,
        reportKey: string,
        /**
         * 다운로드 여부 (true=다운로드, false=미리보기)
         */
        download?: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/{task_id}/report/{report_key}/hwpx',
            path: {
                'task_id': taskId,
                'report_key': reportKey,
            },
            query: {
                'download': download,
            },
        });
    }
    /**
     * Business별 보고서 ZIP 다운로드
     * 특정 Business에 연결된 모든 Task들의 보고서를 PDF 또는 HWPX로 생성하여 ZIP 파일로 압축하여 다운로드합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsTaskViewsDownloadBusinessReportAsZip({
        businessId,
        reportTemplateKey,
        format = 'pdf',
    }: {
        businessId: string,
        /**
         * 템플릿 키 (반복 지정으로 복수 선택 가능, 없으면 활성 템플릿 모두)
         */
        reportTemplateKey?: (Array<string> | null),
        /**
         * 출력 형식: pdf | hwpx (hwp 도 hwpx 로 처리)
         */
        format?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/report/by-business/{business_id}',
            path: {
                'business_id': businessId,
            },
            query: {
                'report_template_key': reportTemplateKey,
                'format': format,
            },
        });
    }
    /**
     * 세부실행과제 보고서 상세 조회
     * 특정 세부실행과제에 대한 보고서 템플릿 기반의 상세 정보를 조회합니다.
     * @returns TaskReportDetailResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskReportDetail({
        taskId,
        reportTemplateId,
    }: {
        taskId: string,
        reportTemplateId: string,
    }): CancelablePromise<TaskReportDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/{task_id}/report/{report_template_id}',
            path: {
                'task_id': taskId,
                'report_template_id': reportTemplateId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * 세부실행과제 보고서 생성
     * TaskReport와 TaskReportInfo를 생성합니다.
     * @returns TaskReportFullResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskReportEndpoint({
        requestBody,
    }: {
        requestBody: ReportCreateRequest,
    }): CancelablePromise<TaskReportFullResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * 세부실행과제 보고서 수정
     * TaskReport 상태를 수정하고 TaskReportInfo를 교체합니다.
     * @returns TaskReportFullResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskReportEndpoint({
        reportId,
        requestBody,
    }: {
        reportId: string,
        requestBody: ReportUpdateRequest,
    }): CancelablePromise<TaskReportFullResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/report/{report_id}',
            path: {
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * Download Period Report
     * 주간/월간 성과보고서를 PDF 또는 HWPX 로 생성해 반환한다.
     *
     * 전체 요약 + 사업별/부서별 현황 표를 포함한다.
     * start_date/end_date 는 선택값이며, 생략 시 전체 기간(날짜 필터 없음)으로 집계한다.
     * (시점 조회는 X-As-Of 헤더로, 기간 필터는 start/end 로 — 역할이 다름)
     * business_id 지정 시 해당 사업으로 필터하고 제목에 사업명을 싣는다(전체면 공란).
     * format=pdf|hwpx (hwp 도 hwpx 로 생성).
     * @returns any OK
     * @throws ApiError
     */
    public static appsTaskViewsDownloadPeriodReport({
        workspaceId,
        period,
        startDate,
        endDate,
        businessId,
        format = 'pdf',
        download = true,
    }: {
        workspaceId: string,
        period: string,
        startDate?: string,
        endDate?: string,
        businessId?: string,
        format?: string,
        download?: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/period-report',
            query: {
                'workspace_id': workspaceId,
                'period': period,
                'start_date': startDate,
                'end_date': endDate,
                'business_id': businessId,
                'format': format,
                'download': download,
            },
        });
    }
}
